import { signal, WritableSignal } from '@angular/core';
import { setStageActive, isStageActive } from './stage-signals'; // assume these are exported
import { BondLookupUIControlStage } from './intake-form-bond-lookup.types';


export interface StageConfig {
  stage: BondLookupUIControlStage;
  defaultActive: boolean;
  children?: StageConfig[];
}

export const stages: StageConfig[] = [
  { stage: BondLookupUIControlStage.State, defaultActive: true },
  { stage: BondLookupUIControlStage.BondFamily, defaultActive: false },
  { stage: BondLookupUIControlStage.StateBond, defaultActive: false },
  { stage: BondLookupUIControlStage.WriteIn, defaultActive: false },
  {
    stage: BondLookupUIControlStage.Penalty,
    defaultActive: false,
    children: [
      { stage: BondLookupUIControlStage.PenaltyOptions, defaultActive: false }
    ]
  },
  { stage: BondLookupUIControlStage.BondSelectionCompleted, defaultActive: false },
];

/**
 * Recursively update the given stage config and, optionally, its children.
 */
export function updateStageConfig(
  config: StageConfig,
  active: boolean,
  propagateToChildren: boolean = true
): void {
  // Update the stage signal
  setStageActive(config.stage, active);

  // If propagating changes and there are children, update each child accordingly.
  if (propagateToChildren && config.children) {
    for (const child of config.children) {
      updateStageConfig(child, active && child.defaultActive, true);
    }
  }
}

/**
 * Helper: Given a stage value, find its corresponding configuration in the hierarchy.
 */
export function findStageConfig(
  stage: BondLookupUIControlStage,
  configs: StageConfig[]
): StageConfig | null {
  for (const config of configs) {
    if (config.stage === stage) {
      return config;
    }
    if (config.children) {
      const found = findStageConfig(stage, config.children);
      if (found) {
        return found;
      }
    }
  }
  return null;
}
